import { defineSlotRecipe } from '@chakra-ui/react';
/**
 * RadioCard disabled-state override, applied globally.
 *
 * Chakra's default dims the whole item with `opacity: 0.5`, which also fades any
 * trailing content in a disabled row (e.g. an inline "connect your mailbox"
 * link) and creates a stacking context a child cannot opt out of. We instead
 * keep the row at full opacity and signal "disabled" through color: a recessed
 * warm-cream fill, a muted title/description and a dimmed radio indicator — so
 * the row reads inactive while any actionable affordance inside it stays legible
 * and clickable. Beyond those `_disabled` states, the only addition is a
 * truncation floor on the content slot; everything else deep-merges with
 * Chakra's base recipe.
 */
export const radioCardRecipe = defineSlotRecipe({
    className: 'chakra-radio-card',
    slots: [
        'root',
        'label',
        'item',
        'itemText',
        'itemDescription',
        'itemControl',
        'itemIndicator',
        'itemAddon',
        'itemContent',
    ],
    base: {
        item: {
            _disabled: { opacity: '1' },
        },
        label: {
            _disabled: { opacity: '1' },
        },
        itemControl: {
            _disabled: { bg: 'background', cursor: 'default' },
        },
        itemIndicator: {
            _disabled: { opacity: '0.4' },
        },
        // Truncation floor. Chakra lays the content out as flex children but leaves
        // the implicit `min-width: auto` on the content slot and, because the
        // default `align: start` variant sets `align-items: flex-start`, lets the
        // text and description slots size to their own content. A long label then
        // spills past the card instead of ellipsising. No card ever wants that, so
        // the constraint belongs here rather than in each caller.
        itemContent: {
            minWidth: '0',
        },
        itemText: {
            maxWidth: '100%',
            _disabled: { color: 'fg.muted' },
        },
        itemDescription: {
            maxWidth: '100%',
        },
    },
});
